import request from '@webtrader/core/request';

export enum EChartPeriod {
  MINUTE_1 = 'PERIOD_M1',
  MINUTE_2 = 'PERIOD_M2',
  MINUTE_3 = 'PERIOD_M3',
  MINUTE_4 = 'PERIOD_M4',
  MINUTE_5 = 'PERIOD_M5',
  MINUTE_6 = 'PERIOD_M6',
  MINUTE_10 = 'PERIOD_M10',
  MINUTE_15 = 'PERIOD_M15',
  MINUTE_20 = 'PERIOD_M20',
  MINUTE_30 = 'PERIOD_M30',
  HOUR_1 = 'PERIOD_H1',
  HOUR_2 = 'PERIOD_H2',
  HOUR_3 = 'PERIOD_H3',
  HOUR_4 = 'PERIOD_H4',
  HOUR_6 = 'PERIOD_H6',
  DAY = 'PERIOD_D1',
  WEEK = 'PERIOD_W1',
  MONTH = 'PERIOD_MN1'
}

export const daySpanPeriods = [
  EChartPeriod.MINUTE_1,
  EChartPeriod.MINUTE_2,
  EChartPeriod.MINUTE_3,
  EChartPeriod.MINUTE_4,
  EChartPeriod.MINUTE_5
];
export const weekSpanPeriods = [
  EChartPeriod.MINUTE_6,
  EChartPeriod.MINUTE_10,
  EChartPeriod.MINUTE_15,
  EChartPeriod.MINUTE_20,
  EChartPeriod.MINUTE_30,
  EChartPeriod.HOUR_1,
  EChartPeriod.HOUR_2,
  EChartPeriod.HOUR_3,
  EChartPeriod.HOUR_4,
  EChartPeriod.HOUR_6
];
export const monthSpanPeriods = [EChartPeriod.DAY];
export const yearSpanPeriods = [EChartPeriod.WEEK, EChartPeriod.MONTH];

export interface IMarketChartData {
  low: number;
  high: number;
  open: number;
  close: number;
  chartTime: number;
  ask?: number;
}

export interface IMarketChartsParams {
  to: number;
  from: number;
  symbol: string;
  period: EChartPeriod;
}

export interface IMarketLatestLiveChartsParams {
  to: number;
  symbol: string;
  period: EChartPeriod;
}

export interface ILatestChartTime {
  chartTime: number;
  ask: number;
  bid: number;
}

export interface IMarketChartLatestParams {
  symbol: string;
  period: EChartPeriod;
}

export default {
  historicalChart: (params: IMarketChartsParams, signal?: AbortSignal) =>
    request.get<IMarketChartData[]>('/api/chart/v4/candlestick', {
      params,
      signal
    }),
  latestBarData: (params: IMarketLatestLiveChartsParams, signal?: AbortSignal) =>
    request.get<IMarketChartData>('/api/chart/v2/candlestick/latest', {
      params,
      signal
    }),
  latestPrice: (params: IMarketChartLatestParams, signal?: AbortSignal) =>
    request.get<ILatestChartTime>('/api/chart/v2/price/latest', {
      params,
      signal
    })
};
